export const FETCH_ALL = 'globalPermissions/FETCH_ALL';
export const FETCH_ALL_SUCCESS = 'globalPermissions/FETCH_ALL_SUCCESS';
export const FETCH_ALL_ERROR = 'globalPermissions/FETCH_ALL_ERROR';

export const UPDATE = 'globalPermissions/UPDATE';
export const UPDATE_SUCCESS = 'globalPermissions/UPDATE_SUCCESS';
export const UPDATE_ERROR = 'globalPermissions/UPDATE_ERROR';
